import request from "@/utils/request.js"

// 品牌方-新增
export const addBrand = (formData) => {
    return request.post(`/brand`, formData)
}

// 品牌方-详情
export const getBrand = (id) => {
    return request.get(`/brand/${id}`)
}

// 品牌方-修改
export const updateBrand = (updateData) => {
    return request.put(`/brand`, updateData);
};
